import { GyldendalLogoSmall } from '@ui/kit/icons';
import { throbberCls } from './atom.throbber.style.js';
import { jsx } from 'react/jsx-runtime';

function Throbber({
  height = 60
}) {
  return /*#__PURE__*/jsx("i", {
    className: throbberCls,
    children: /*#__PURE__*/jsx(GyldendalLogoSmall, {
      height: height,
      disableDefaultClassName: true
    })
  });
}

export { Throbber };
//# sourceMappingURL=atom.throbber.js.map
